<template>
  <!--新增对话框-->
  <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="新增优惠券"
      width="800"
  >
    <el-form
        ref="editForm"
        :model="editForm"
        :rules="editFormRules"
        class="demo-editForm"
        label-width="100px"
    >
      <el-form-item label="券名称" label-width="150px" prop="name">
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="优惠券类型" label-width="150px" prop="waysObtain">
        <el-select
            v-model="editForm.waysObtain"
            clearable
            placeholder="优惠券"
            style="width: 100%;"
        >
          <el-option label="单笔消费满多少送" value="1"></el-option>
          <el-option label="新用户注册" value="2"></el-option>
          <el-option label="活动赠送券" value="3"></el-option>
          <el-option label="折扣券" value="4"></el-option>
          <el-option label="品类券" value="5"></el-option>
          <el-option label="单品券" value="6"></el-option>
          <el-option label="邀新并下单" value="7"></el-option>
          <el-option label="邀新并注册" value="9"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          v-if="editForm.waysObtain == 1"
          label="单笔满多少送(元)"
          label-width="150px"
          prop="waysObtainMoney"
      >
        <el-input
            v-model="editForm.waysObtainMoney"
            autocomplete="off"
            type="number"
        ></el-input>
      </el-form-item>

      <el-form-item
          v-if="editForm.waysObtain == 4"
          label="折扣率"
          label-width="150px"
          prop="discount"
      >
        <el-input
            v-model="editForm.discount"
            autocomplete="off"
            placeholder="例：8折为0.8"
            type="number"
            @input="numValid(editForm.discount)"
        ></el-input>
      </el-form-item>
      <el-form-item
          v-if="editForm.waysObtain == 5"
          label="商品分类"
          label-width="150px"
          prop="classifyId"
      >
        <el-cascader
            ref="cateData"
            v-model="editForm.classifyId"
            :options="typeList"
            :props="{ value: 'uid', label: 'name', children: 'children' }"
            clearable
            filterable
            placeholder="选择分类"
            style="width: 100%;"
            @change="handleChange"
        ></el-cascader>
      </el-form-item>

      <el-form-item
          v-if="editForm.waysObtain == 4"
          label="折扣可用件数"
          label-width="150px"
          prop="discountNum"
      >
        <el-input
            v-model="editForm.discountNum"
            autocomplete="off"
            type="number"
        ></el-input>
      </el-form-item>
      <el-form-item
          v-if="editForm.waysObtain == 6||editForm.waysObtain == 4"
          label="选择商品"
          label-width="150px"
          prop="tcommodityId"
      >
        {{ editForm.commodityName }}
        <el-button type="primary" @click="setshop('')">选择商品</el-button>
      </el-form-item>
   <el-form-item label="开始使用时间" label-width="150px" prop="startTime">
        <el-date-picker
          v-model="editForm.startTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择时间"
          style="width:100%"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="有效期(/天)" label-width="150px" prop="validTime">
        <el-input
            v-model="editForm.validTime"
            autocomplete="off"
            type="number"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="editForm.waysObtain == 2" label="券总数" label-width="150px" prop="num">
        <el-input
            v-model="editForm.num"
            autocomplete="off"
            type="number"
        ></el-input>
      </el-form-item>
      <el-form-item
          v-if="editForm.waysObtain != 4"
          label="优惠规则类型"
          label-width="150px"
          prop="type"
      >
        <el-radio-group v-model="editForm.type" @change="rulesTypeChange">
          <el-radio :label="1">无门槛</el-radio>
          <el-radio :label="2">满减</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
          v-if="editForm.waysObtain != 4"
          label="是否可叠加使用"
          label-width="150px"
          prop="isSuperposition"
      >
        <el-radio-group v-model="editForm.isSuperposition">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
          label="获得方式"
          label-width="150px"
          prop="releaseMode"
      >
        <el-radio-group v-model="editForm.releaseMode">
          <el-radio :label="1">自动发放</el-radio>
          <el-radio :label="2">用户领取</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
          v-if="editForm.waysObtain != 4"
          label="优惠金额(元)"
          label-width="150px"
          prop="discountAmount"
      >
        <el-input
            v-model="editForm.discountAmount"
            autocomplete="off"
            type="number"
        ></el-input>
      </el-form-item>
      <el-form-item
          v-if="editForm.type == 2"
          label="满减条件金额(元)"
          label-width="150px"
          prop="satisfyAmount"
      >
        <el-input
            v-model="editForm.satisfyAmount"
            autocomplete="off"
            type="number"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="saveCoupons('editForm')"
        >保存
        </el-button
        >
      </el-form-item>
    </el-form>

    <el-dialog
        :before-close="handlecrile"
        :visible.sync="shopVisible"
        append-to-body
        title="选择商品"
        width="80%"
    >
      <div style="padding-bottom: 40px;">
        <el-form :inline="true">
          <el-form-item label="商品名" label-width="80px">
            <el-input v-model="shopForm.name" clearable placeholder="商品名">
            </el-input>
          </el-form-item>
          <el-form-item label="商品分类" label-width="80px">
            <el-cascader
                ref="cateData"
                v-model="classifyId"
                :options="typeList"
                :props="{
                checkStrictly: true,
                value: 'id',
                label: 'name',
                children: 'children',
              }"
                clearable
                filterable
                placeholder="选择分类"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="getsch()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
            ref="multipleTable"
            :data="shopData"
            border
            stripe
            style="width: 100%;"
        >
          <el-table-column
              align="center"
              label="商品封面"
              prop="storeGoodsCover"
              width="100"
          >
            <template slot-scope="scope">
              <el-image
                  :src="scope.row.cover"
                  fit="scale-down"
                  style="width: 70px; height: 70px;"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="商品名称"
              prop="name"
          ></el-table-column>
          <el-table-column
              align="center"
              label="商品类型"
              prop="firstClassifyName"
              width="148"
          >
            <template slot-scope="scope">
              {{ scope.row.firstClassifyName }}-{{ scope.row.classifyName }}
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              fixed="right"
              label="操作"
              prop="icon"
              width="300"
          >
            <template slot-scope="scope">
              <el-button plain type="primary" @click="chooseshop(scope.row)">{{
                  editForm.tcommodityId == scope.row.id ? "已选择" : "选择"
                }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            :current-page="currentd"
            :page-size="sized"
            :page-sizes="[10, 20, 50, 100]"
            :total="totald"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="shopSizeChange"
            @current-change="shopCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  name: "AddUpdateCoupons",
  components: {},
  data() {
    return {
      shopVisible: false,
      shopData: [],
      editForm: {},
      avatar: "",
      fileList: [],
      typeList: [],
      classifyId: [],
      totald: 0,
      sized: 10,
      currentd: 1,
      urlList: [],
      supList: [],
      names: "拉新用户完成首单",
      newcomerCoupon: false,
      dialogVisible: false,
      shopForm: {
        pageNo: 1,
        pageSize: 10,
        storeGoodsType: "",
        supplierName: "",
        classifyFirstId: "",
        name: "",
        type: 0,
        num:0
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        waysObtain: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择优惠规则类型",
            trigger: "blur",
          },
        ],
        discountAmount: [
          {
            required: true,
            message: "优惠券金额",
            trigger: "blur",
          },
        ],

        validTime: [
          {
            required: true,
            message: "请输入优惠券有效期",
            trigger: "blur",
          },
        ],
        timeLimitType: [
          {
            required: true,
            message: "请选择时间类型",
            trigger: "blur",
          },
        ],
        classifyId: [
          {
            required: true,
            message: "请选择品类",
            trigger: "blur",
          },
        ],
        tcommodityId: [
          {
            required: true,
            message: "请选择产品",
            trigger: "blur",
          },
        ],
        discount: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        num: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        discountNum: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    shopCurrentChange(val) {
      this.currentd = val;
      this.getStoreGoods();
    },
    shopSizeChange(val) {
      this.currentd = val;
      this.getStoreGoods();
    },
    setshop() {
      this.shopVisible = true;
      this.getStoreGoods();
    },

    handlecrile() {
      this.crileVisible = false;
      this.shopVisible = false;
    },
    getsch() {
      this.currentd = 1;
      this.getStoreGoods();
    },
    getStoreGoods() {
      if (this.classifyId.length > 0) {
        this.shopForm.classifyFirstId = this.classifyId[0];
        if (this.classifyId.length > 1) {
          this.typeList.map((item) => {
            item.children.map((itrs) => {
              if (this.classifyId[1] == itrs.id) {
                this.shopForm.classifyId = itrs.uid;
              }
            });
          });
        } else {
          this.shopForm.classifyId = "";
        }
      } else {
        this.shopForm.classifyId = "";
        this.shopForm.classifyFirstId = "";
      }
      this.shopForm.pageNo = this.currentd;
      this.shopForm.pageSize = this.sized;
      this.shopForm.type = 0;

      this.$axios
          .post("/admin/commodity/getUpperCommodityList", this.shopForm)
          .then((res) => {
            this.shopData = res.data.records;
            this.sized = res.data.size;
            this.currentd = res.data.current;
            this.totald = res.data.total;
          });
    },
    getTypeList() {
      this.$axios
          .get("/admin/commodityClassify/getAllLevelList")
          .then((res) => {
            this.typeList = res.data;
          });
    },
    numValid(discount) {
      var reg = /^(0.\d+|0|1)$/;
      if (reg.test(discount)) {
        this.editForm.discount = discount;
      } else {
        if (discount != "0.") this.editForm.discount = 0;
      }
    },
    change(val) {
      this.editForm.content = val;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.editForm = {};
    },
    handleClose() {
      this.resetForm("editForm");
    },
    rulesTypeChange() {
      console.log("ws====>>");
      if (this.editForm.type == 1) {
        this.editForm.satisfyAmount = 0;
      } else {
      }
    },
    chooseshop(e) {
      console.log(e)
      this.editForm.tcommodityId = e.id;
      this.editForm.commodityName = e.name;
      this.shopVisible = false;
    },
    saveCoupons(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = JSON.parse(JSON.stringify(this.editForm));
          if (obj.classifyId.length > 1) {
            obj.classifyId = this.editForm.classifyId[1];
          } else {
            obj.classifyId = "";
          }
          this.$axios.post("/admin/sysCouponSheet/add", obj).then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
              },
            });
            this.$emit("refreshDataList");
            this.dialogVisible = false;
          });
        }
      })
    },
    handleChange(value) {
    },
    init(id) {
      this.getTypeList();
      this.getStoreGoods();
      this.dialogVisible = true;
      if (id != null && id != "" && id > 0) {
        this.$axios
            .post("/admin/coupons/getCouponsInfo", {
              couponsId: id,
            })
            .then((res) => {
              this.editForm = res.data;
              var termValidity = [];
              if (res.data) {
                termValidity.push(res.data.startTime);
                termValidity.push(res.data.endTime);
                this.editForm.termValidity = termValidity;
              }
            });
      } else {
        this.editForm = {
          discount: 0,
          discountAmount: "",
          commodityName: "",
          tcommodityId: "",
          name: "",
          isSuperposition: 0,
          releaseMode: 1,
          satisfyAmount: "",
          type: 1,
          userOriented: 1,
          validTime: "",
          classifyId: [],
          num:0,
          timeLimitType: 0,
          startTime: "",
        };
      }
    },
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
